import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { HttpContextToken } from '@angular/common/http';

export type SourceCodeExcludeRepoRequestParams = {
    [key: string]: any;
};

@Injectable({
    providedIn: 'root',
})
export class SourceCodeExcludeRepoService {

    constructor (
        private apiService: ApiService,
    ) { }

    get (sourceExcludeId: string | number, params?: SourceCodeExcludeRepoRequestParams, contextToken?: HttpContextToken<unknown>): Promise<any> {
        params = params || {};
        return this.apiService.get(`source_code_excludes/${sourceExcludeId}`, params, {}, contextToken);
    }

    getAll (params?: SourceCodeExcludeRepoRequestParams, contextToken?: HttpContextToken<unknown>): Promise<any> {
        params = params || {};
        return this.apiService.get('source_code_excludes', params, {}, contextToken);
    }

    create (sourceExclude: any, params?: SourceCodeExcludeRepoRequestParams, contextToken?: HttpContextToken<unknown>): Promise<any> {
        params = params || {};
        return this.apiService.post('source_code_excludes', sourceExclude, contextToken);
    }

    update (sourceExclude: any, updatedSourceExclude: any, params?: SourceCodeExcludeRepoRequestParams): Promise<any> {
        return this.apiService.patch(`source_code_excludes/${sourceExclude.id}`, updatedSourceExclude, params);
    }

    destroy (sourceExcludeId: string | number, params?: SourceCodeExcludeRepoRequestParams): Promise<any> {
        params = params || {};
        return this.apiService.delete(`source_code_excludes/${sourceExcludeId}`, params);
    }
}
